import { render, staticRenderFns } from "./InformeObligacion.vue?vue&type=template&id=75b7a805&"
import script from "./InformeObligacion.vue?vue&type=script&lang=js&"
export * from "./InformeObligacion.vue?vue&type=script&lang=js&"
import style0 from "./InformeObligacion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports